__turbopack_context__.v({
  "content": "TicketingInstruction-module__1xFcxW__content",
  "subtitle": "TicketingInstruction-module__1xFcxW__subtitle",
  "ticketTitle": "TicketingInstruction-module__1xFcxW__ticketTitle",
  "title": "TicketingInstruction-module__1xFcxW__title",
});
